<template>
  <div class="history-user-id-input" :class="cssType">
    <ElPopover
      v-model:visible="showPopover"
      placement="bottom-start"
      :width="popoverWidth"
      teleported
      popper-class="history-user-id-popper"
      trigger="click"
    >
      <template #reference>
        <span class="input-popover-reference"></span>
      </template>
      <div class="history-account-list">
        <div
          v-for="(item, index) in historyAccount"
          :key="index"
          class="history-account-item"
          @mousedown.prevent="onSelectHistory(item)"
        >
          {{ item }}
        </div>
      </div>
    </ElPopover>
    <input
      :class="locale"
      :value="modelValue"
      @input="onInput"
      @focus="handleInputFocus"
      @blur="handleInputBlur"
      type="text"
      autocomplete="off"
      :placeholder="placeholder"
    >
  </div>
</template>

<script setup>
import { ref, computed, defineProps, defineEmits } from 'vue'
import { ElPopover } from 'element-plus'
import { useStore } from 'vuex'
import { isMobile, parseHistoryAccountId } from '@/utils'

defineProps({
  modelValue: {
    type: String,
    default: ''
  },
  locale: {
    type: String,
    default: ''
  },
  placeholder: {
    type: String,
    default: ''
  }
})

const emit = defineEmits(['update:modelValue'])

const cssType = isMobile ? 'mobile' : 'pc'
const store = useStore()
const historyAccount = computed(() => store.state.historyAccount)
const showPopover = ref(false)
const popoverWidth = isMobile ? 250 : 400

const normalizeUserId = (val) => {
  return String(val).replace(/\s+/g, '').replace(/[^a-zA-Z0-9]/g, '').toUpperCase()
}

const onInput = (e) => {
  const newVal = normalizeUserId(e.target.value)
  e.target.value = newVal
  emit('update:modelValue', newVal)
}

const handleInputFocus = () => {
  if (historyAccount.value.length) {
    showPopover.value = true
  }
}

const handleInputBlur = () => {
  showPopover.value = false
}

const onSelectHistory = (item) => {
  emit('update:modelValue', normalizeUserId(parseHistoryAccountId(item)))
  showPopover.value = false
}
</script>

<style src="./pc_style.less" lang="less" scoped></style>
<style src="./mobile_style.less" lang="less" scoped></style>
<style src="./popper.less" lang="less"></style>
